import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg viewBox="0 0 401.998 401.998" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
    <path
      d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675z"
      fill="fj-icons-primary-color"
    />
  </svg>
);

const Lock = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Lock;
